import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';

@Injectable()
export class PaymentService {
  constructor(private api: ApiService) {}

  private url = `${environment.reportApiUrl}/payment`;
  private reportUrl = `${environment.reportApiUrl}/report`;

  getIds(paymentType: string) {
    switch (paymentType) {
      case 'ADVISOR':
        return this.getAdvisors();
      case 'PARTNER':
        return this.getPartners();
      case 'CUSTOMER':
        return this.getCustomers();
      default:
        return of([]);
    }
  }

  getAdvisors() {
    return this.api.get(`${this.reportUrl}/advisors`);
  }

  getPartners() {
    return this.api.get(`${this.reportUrl}/partners`);
  }

  getCustomers() {
    return this.api.get(`${this.reportUrl}/customers`);
  }
}

// import { Injectable } from '@angular/core';
// import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
// import { LoggerService } from './logger.service';

// @Injectable({
//   providedIn: 'root'
// })
// export class PaymentService {
//   baseUrl = 'https://api.qezyplay.com/api/'
//   constructor(private logger: LoggerService, private http: HttpClient) { }

//   encryptdata(request) {
//     let url = `${this.baseUrl}channels/encryptFormData`;
//     let data = {
//       request: request
//     }
//     return this.http.get(url, { params: data })
//   }
// }
